import React from "react";
import Create from "modules/countries/components/Create";

const CountriesCreatePage = () => {
  return <Create />;
};

export default CountriesCreatePage;
